<div class="markant-header">
  <a class="logo" (click)="isLogoutPage ? toMarkantWebsite() : toLandingPage()">
    <markant-header-logo-bar
      logoUrl="assets/images/logo/markant-logo.svg"
    ></markant-header-logo-bar>
  </a>
  <div class="buttons-header">
    <markant-platform-language-selection></markant-platform-language-selection>
    @if (loginButton) {
      <markant-button
        (click)="toLoginPage()"
        (keydown.enter)="toLoginPage()"
        colorScheme="primary"
      >
        {{ 'auth.login' | transloco }}</markant-button
      >
    }
  </div>
</div>
